export default {
  selectBypassPaywall: (state) => state.bypassPaywall,
};
